import script from "./manage-blueprints.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-blueprints.vue?vue&type=script&setup=true&lang=js"

import "./manage-blueprints.vue?vue&type=style&index=0&id=f90c5c98&lang=css"

const __exports__ = script;

export default __exports__